import { InjectionToken } from '@angular/core';

export type AppAudience = 'consultant' | 'shm';

export const APP_AUDIENCE = new InjectionToken<AppAudience>('app.audience');
